import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatTableModule } from '@angular/material/table';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { debounceTime } from 'rxjs';
import { PositionService } from '../../../core/api/position.service';
import { BasePageComponent } from '../../../core/classes/base-page';
import { AuthService } from '../../../core/services/auth.service';
import { HelpersService } from '../../../core/services/helpers.service';
import { LoadingService } from '../../../core/services/loading.service';

@Component({
  selector: 'app-position',
  standalone: true,
  imports: [
    CommonModule,
    MatTableModule,
    MatPaginatorModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    MatMenuModule,
  ],
  templateUrl: './position.component.html',
  styleUrl: './position.component.scss',
})
export class PositionComponent
  extends BasePageComponent<any>
  implements OnInit
{
  searchFormControl = new FormControl();

  constructor(
    public override helpers: HelpersService,
    public override router: Router,
    public override activatedRoute: ActivatedRoute,
    public override dialog: MatDialog,
    public override loading: LoadingService,
    public override service: PositionService,
    public override authService: AuthService,
  ) {
    super(
      helpers,
      router,
      activatedRoute,
      dialog,
      loading,
      service,
      authService,
    );
    this.displayedColumns = [
      'no',
      'name',
      'code',
      'reportScope',
      'description',
      'created_at',
      'updated_at',
      'action',
    ];
    this.sortActive = 'updated_at';
    this.sortDirection = 'desc';
  }

  override ngOnInit(): void {
    super.ngOnInit();

    this.searchFormControl.valueChanges
      .pipe(debounceTime(300))
      .subscribe((val: any) => {
        this.q.search = val;
        this.getData();
      });
  }

  override afterInit(): void {
    if (!this.data) this.loading.startLoading();
    this.service
      .getAll(this.q)
      .then((data) => {
        this.assignData(data);
        this.afterGetData();
        this.loading.endLoading();
      })
      .catch((err) => {
        this.helpers.sbError(err);
        this.loading.endLoading();
      });
  }

  override getData(): void {
    this.loading.startLoading();
    this.service
      .getAll(this.q)
      .then((data) => {
        this.assignData(data);
        this.afterGetData();
        this.loading.endLoading();
      })
      .catch((err) => {
        this.helpers.sbError(err);
        this.loading.endLoading();
      });
  }

  addPosition(): void {
    this.router.navigate(['/dashboard/position/action'], {
      queryParams: {
        m: 'add',
      },
    });
  }

  editPosition(id: any): void {
    this.router.navigate(['/dashboard/position/action'], {
      queryParams: {
        m: 'edit',
        id,
      },
    });
  }
}
